import { Box, Button, Grid, Typography } from "@mui/material";
import { SubscriptionContext } from "contexts/Subscription";
import { useContext } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { SearchParams } from "schemas/dashboard";
import { Plans } from "schemas/payments";
import { routes } from "schemas/routes";

import StyledVideo from "components/Styled/Video";
import {
  PRO_IMAGE_PREVIEW_LINK,
  PRO_SUBSCRIPTION_VIDEO_LINK,
  VA_IMAGE_PREVIEW_LINK,
  VA_SUBSCRIPTION_VIDEO_LINK,
} from "constants/influencer";

const SuccessPage = () => {
  const [searchParams] = useSearchParams();
  const planName = searchParams.get(SearchParams.PLAN_NAME);
  const { setUpgradeDialogSource } = useContext(SubscriptionContext);

  const isVa = planName === Plans.VA_YEARLY || planName === Plans.VA;
  const isYearly =
    planName === Plans.PRO_YEARLY || planName === Plans.VA_YEARLY;

  const navigate = useNavigate();

  const goBack = () => {
    navigate(`/${routes.settings}`);
    setUpgradeDialogSource(null);
  };

  return (
    <Grid
      item
      xs
      container
      alignItems="center"
      justifyContent={"center"}
      sx={{
        backgroundColor: "green.dark",
        position: "absolute",
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
      }}
    >
      <Box
        sx={{
          backgroundColor: { xs: "none", md: "green.main" },
          p: { xs: 2, md: 10 },
          borderRadius: 4,
          textAlign: "center",
        }}
      >
        <Typography
          variant="h4"
          textAlign="center"
          sx={{ mb: 3, color: "white" }}
        >
          🎉 Thanks for subscribing to Bento
        </Typography>

        <Box sx={{ mb: 3 }}>
          <StyledVideo
            image={isVa ? VA_IMAGE_PREVIEW_LINK : PRO_IMAGE_PREVIEW_LINK}
            videoPreview={isVa ? VA_IMAGE_PREVIEW_LINK : PRO_IMAGE_PREVIEW_LINK}
            link={
              isVa ? VA_SUBSCRIPTION_VIDEO_LINK : PRO_SUBSCRIPTION_VIDEO_LINK
            }
            title={`Make the Most of Your ${isVa ? "Virtual Assistant" : "Pro"} Subscription`}
            widthPercentage={isVa ? 100 : 30}
          />
        </Box>

        {isYearly && (
          <Typography textAlign="center" sx={{ color: "white" }}>
            Keep an eye on your inbox — we'll send you a special promo code for{" "}
            <strong>one free template</strong> purchase.
            <br />
            We can't wait to see what you'll build. 💜
          </Typography>
        )}

        <Grid item container justifyContent="center" sx={{ mt: 3 }}>
          <Button onClick={goBack} sx={{ color: "yellow.main" }}>
            Go to Dashboard{" "}
            <Box
              component="i"
              className="fa-solid fa-arrow-right"
              sx={{ ml: 1 }}
            />
          </Button>
        </Grid>
      </Box>
    </Grid>
  );
};

export default SuccessPage;
